import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesRolesMain } from './modules/ui/Main';

const RolesPage = (
  <SuspensePage>
    <PagesRolesMain />
  </SuspensePage>
);

export default RolesPage;
